import { ref } from 'vue'
import type { CockpitFinancials, TimeRange, FinancialBucket } from '@/types/cockpit'
import { fetchCockpitFinancials } from '@/api/cockpit'

export function useCockpitFinancials() {
  const data = ref<CockpitFinancials | null>(null)
  const loading = ref(false)
  const error = ref<string | null>(null)

  async function fetch(range: TimeRange, bucket: FinancialBucket): Promise<void> {
    loading.value = true
    error.value = null
    try {
      data.value = await fetchCockpitFinancials(range, bucket)
    } catch {
      error.value = 'admin.cockpit.finance.error'
    } finally {
      loading.value = false
    }
  }

  return { data, loading, error, fetch }
}
